import React from "react";
import Thermometer from "react-thermometer-component";
import { Row, Col } from "react-bootstrap";

const FuelGuage = (props) => {
  const { reading, title, unit } = props;
  return (
    <div className="tw-font-nunito tw-py-8 tw-m-3 tw-bg-sky-900 tw-rounded-md tw-shadow-md sm:tw-w-3/12 tw-w-4/5">
      <div className="tw-flex md:tw-flex-div tw-flex-col tw-justify-center tw-items-center">
        <div className="sm:tw-text-xl tw-my-4 tw-font-bold">
          <Thermometer
            theme="dark"
            value={reading}
            max="100"
            steps="5"
            format="%"
            size="large"
            height="250"
          />
        </div>
        <div className="tw-text-center tw-text-white sm:tw-text-xl tw-text-lg tw-font-bold">
          {title}
          <p className="sm:tw-text-2xl tw-text-xl tw-mb-0">
            {reading} {unit}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FuelGuage;
